/* Copyright (c) 2026 Hyegro Pty Ltd. All rights reserved. */

/**
 * Button base. Pill shape stays (it is part of the brand); the label is
 * sentence case at 13px/600 rather than 12px uppercase bold, and the heights
 * sit on the same 32 / 40 / 48 grid as the form controls.
 */

import typography from "assets/theme-dark/base/typography";
import borders from "assets/theme-dark/base/borders";
import pxToRem from "assets/theme-dark/functions/pxToRem";

const { fontFamily } = typography;
const { borderRadius } = borders;

const root = {
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  gap: pxToRem(8),
  fontFamily,
  fontSize: pxToRem(13),
  fontWeight: 600,
  lineHeight: 1.4,
  letterSpacing: 0,
  borderRadius: borderRadius.section,
  minHeight: pxToRem(40),
  padding: `0 ${pxToRem(20)}`,
  textAlign: "center",
  textTransform: "none",
  userSelect: "none",
  backgroundSize: "150% !important",
  backgroundPositionX: "25% !important",
  transition: "all 150ms ease-in",

  "&:disabled": {
    pointerEvents: "none",
    opacity: 0.65,
  },

  "& .material-icons, & .material-icons-round, & svg": {
    fontSize: pxToRem(18),
    marginTop: 0,
  },
};

export default root;
